import uniqueId from "lodash/uniqueId";
import { useRef } from "react";
export const useUniqueId = (prefix = "", externalId) => {
    const idRef = useRef(externalId);
    if (!idRef.current) {
        idRef.current = uniqueId(prefix);
    }
    return idRef.current;
};
